import { ValidationProps, ValidationMessage } from 'ui';

export const getValidationWithoutDuplicates = (validation: ValidationProps) =>
  ({ ...validation, messages: filterMessageDuplicates(validation) });

const filterMessageDuplicates = (validation: ValidationProps) => !!validation && !!validation.messages
  ? filterMessageDuplicatesInternal(validation) : [];

const filterMessageDuplicatesInternal = (validation: ValidationProps) => {
  let messageOcurrencesMap = {};

  const isAlreadyInMessages = (message: string) => !!messageOcurrencesMap[message];

  const markMessageAsPresent = (message: string) => { messageOcurrencesMap[message] = 1 };

  const result = validation.messages.map<ValidationMessage>(message => {
    if (isAlreadyInMessages(message.message)) {
      return { ...message, message: '' };
    } else {
      markMessageAsPresent(message.message);
      return message;
    }
  });

  messageOcurrencesMap = {};

  return result;
};
